<app-entity-crud-page-template
  [data]="tenants"
  [columns]="columns"
  [loading]="loading"
  (onCreate)="saveTenant()"
  (onDeleteSelected)="deleteSelectedTenants($event)"
  [enableSearch]="false"
  [enableFilterReset]="true"
/>
